import axios from "axios";

export default function getGroupRules(uuid) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `/account/api/v1/branch-group/branch-rules?branch_group_uuid=${uuid}`
      )
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
